import type { SVGProps } from 'react';

const SvgPlayerPan = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12.24 22c-2.3 0-4.47-1.01-5.95-2.77-.52-.62-1.61-2.61-1.94-3.4l-2.12-4.07s-.04-.07-.05-.11c-.53-1.42.19-3.01 1.61-3.54.75-.28 1.56-.21 2.22.13v-2.5A2.5 2.5 0 0 1 9.05 3.3a2.5 2.5 0 0 1 2.46-2.06c1.23 0 2.25.89 2.46 2.06a2.5 2.5 0 0 1 3 2 2.5 2.5 0 0 1 3.04 2.44v6.5c0 4.28-3.49 7.77-7.77 7.77zM4.03 10.9l2.11 4.05s.03.06.04.09c.25.63 1.28 2.48 1.64 2.9A5.76 5.76 0 0 0 12.24 20c3.18 0 5.77-2.59 5.77-5.77v-6.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5v2.61c0 .55-.45 1-1 1s-1-.45-1-1V5.73c0-.28-.22-.5-.5-.5s-.5.22-.5.5v4.61c0 .55-.45 1-1 1s-1-.45-1-1V3.73c0-.28-.22-.5-.5-.5s-.5.22-.5.5v6.61c0 .55-.45 1-1 1s-1-.45-1-1V5.73c0-.28-.22-.5-.5-.5s-.5.22-.5.5v6c0 .48-.35.9-.82.98a.985.985 0 0 1-1.11-.64l-.62-1.67a.747.747 0 0 0-1.41.49z"
    />
  </svg>
);
export default SvgPlayerPan;
